var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","rounded":"lg"}},[_c('v-card-title',{staticClass:"primary--text"},[_vm._v("Minhas Experiências Profissionais")]),_c('v-card-text',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_c('experiencias-profissionais')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }